import React, {Component, ComponentType} from 'react';
import {DropdownControlled} from '@homeaway/react-dropdown';
import {getFreeCancellationFilters} from '../../utils/filters';
import DropdownPanel from '../DropdownPanel/DropdownPanel';
import FreeCancellationFilter from '../FreeCancellationFilter/FreeCancellationFilter';
import {Refinement} from '../FilterGroup/FilterGroup';

type ProviderComponent = {
    searchResultsLoading: boolean;
};

type Props = {
    toggleDropdown: Function;
    applyFilters: () => void;
    closeDropdowns: () => void;
    open: boolean;
    label: string;
    searchFilters: string[];
    searchResultsLoading: boolean;
    filterCountDataProvider: ComponentType<ProviderComponent>;
    updateMultipleFilterCheck: (updatedFilters: Refinement[]) => void;
};

const CANCELLATION_POLICIES_FILTER_ID = 'cancellationPoliciesFilter';

export class CancellationPoliciesFilterDropdown extends Component<Props> {
    renderCancellationPoliciesFilter = ({filterGroups}) => {
        const {
            searchFilters,
            updateMultipleFilterCheck,
            applyFilters,
        } = this.props;
        const cancellationFilters = getFreeCancellationFilters(filterGroups);
        return (
            <DropdownPanel showButtons onApply={applyFilters}>
                <FreeCancellationFilter
                    filters={cancellationFilters}
                    selectedFilters={searchFilters}
                    onMultipleFilterToggle={updateMultipleFilterCheck}
                    oldExperience
                />
            </DropdownPanel>
        );
    };

    render() {
        const {
            renderCancellationPoliciesFilter,
            props: {
                searchResultsLoading,
                open,
                applyFilters,
                label,
                toggleDropdown,
                filterCountDataProvider: FilteredCountDataProvider,
            },
        } = this;

        return (
            <DropdownControlled
                id={CANCELLATION_POLICIES_FILTER_ID}
                label={label}
                onDropdownClick={toggleDropdown(
                    CANCELLATION_POLICIES_FILTER_ID
                )}
                onBlur={applyFilters}
                onTouch={applyFilters}
                open={open}
            >
                {open && (
                    <FilteredCountDataProvider
                        children={renderCancellationPoliciesFilter}
                        searchResultsLoading={searchResultsLoading}
                    />
                )}
            </DropdownControlled>
        );
    }
}

export default CancellationPoliciesFilterDropdown;
